import { notifications } from '@mantine/notifications';
import messages from '../../../shared/constants/messages';
import { UpdateOrderState } from '../type';

const decreaseMenuItemById = (state: UpdateOrderState, id: string): UpdateOrderState => {
  const menuItem = state?.updatedOrder?.orderItems?.find((x) => x.id === id);

  if (menuItem) {
    if (menuItem?.count && menuItem?.count > 1) {
      return {
        ...state,
        updatedOrder: {
          ...state?.updatedOrder,
          orderItems:
            state?.updatedOrder?.orderItems?.map((item) => {
              if (item.id === id) {
                return {
                  ...item,
                  count: (item.count || 0) - 1,
                  toppings: item?.toppings?.map((x) => ({
                    ...x,
                    count: (item.count || 0) - 1,
                  })),
                };
              }
              return item;
            }) || [],
        },
      };
    }

    const orderOrderItems = state?.updatedOrder?.orderItems
      ?.filter((x) => x.id !== id)
      .reduce((acc, cur) => acc + (cur?.count || 0), 0);
    if (orderOrderItems === 0) {
      notifications.show({
        message: messages.NOT_ALLOW_REMOVE_ALL_ITEMS,
        color: 'red',
      });

      return state;
    }
    return {
      ...state,
      updatedOrder: {
        ...state?.updatedOrder,
        orderItems: state?.updatedOrder?.orderItems?.filter((x) => x.id !== id),
      },
      removedItems: [
        ...(state?.removedItems || []),
        ...(state?.order?.data?.orderItems?.filter((x) => x.id === id) || []),
      ],
    };
  }
  return state;
};

export default decreaseMenuItemById;
